import { render } from "./FullscreenOverlay.vue?vue&type=template&id=6af4b1a6&ts=true"
import script from "./FullscreenOverlay.vue?vue&type=script&lang=ts"
export * from "./FullscreenOverlay.vue?vue&type=script&lang=ts"

import "./FullscreenOverlay.vue?vue&type=style&index=0&id=6af4b1a6&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__